import React, { useId } from 'react';
import PropTypes from 'prop-types';

import PdpIcon from '../product/pdpIcon';

export const SIGNUP_NOTE = 'Once a month, plus the occasional special offer. Unsubscribe any time.';
export const UNSUBSCRIBE_NOTE = 'Changed your mind? Every email has an unsubscribe link.';

// Email field, error and note of the Press Sheet signup, from the "Signup error states" frames in
// design/website.pen. `tone` picks the light (archive) or dark (green tile) colors.
// Styles: styles/_newsletter.scss (nlf- prefix).
const NewsletterForm = ({ signup, tone }) => {
  const errorId = useId();
  const { submitting, error, onSubmit } = signup;

  return (
    // POST so a native submit before hydration never puts the email in the URL.
    <form className={`nlf nlf--${tone}`} method="post" onSubmit={onSubmit}>
      <div className={`nlf-box${error?.invalid ? ' nlf-box--invalid' : ''}`}>
        <label className="nlf-field">
          <PdpIcon name="mail" size={18} />
          <span className="sr-only">Email address</span>
          <input
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder="Enter your email"
            aria-invalid={error?.invalid || undefined}
            aria-describedby={error ? errorId : undefined}
          />
        </label>
        {/* Bot trap: hidden from people and assistive tech, bots fill every field. */}
        <div className="nlf-trap" aria-hidden="true">
          <input type="text" name="website" tabIndex={-1} autoComplete="off" />
        </div>
        <button type="submit" className="nlf-submit" disabled={submitting}>
          Subscribe
        </button>
      </div>
      {error && (
        <p id={errorId} className="nlf-error" role="alert">
          <PdpIcon name="circleAlert" size={16} />
          {error.message}
        </p>
      )}
      <p className="nlf-note">{SIGNUP_NOTE}</p>
    </form>
  );
};

NewsletterForm.propTypes = {
  // Return value of useNewsletterSignup.
  signup: PropTypes.shape({
    submitting: PropTypes.bool,
    error: PropTypes.shape({ message: PropTypes.string, invalid: PropTypes.bool }),
    onSubmit: PropTypes.func.isRequired,
  }).isRequired,
  tone: PropTypes.oneOf(['light', 'dark']).isRequired,
};

export default NewsletterForm;
